import React, { Component, PureComponent, Fragment } from 'react'
import { Icon, Dimmer, Loader, Message } from 'semantic-ui-react'
import { Map, List, fromJS } from 'immutable'
import { connect } from 'react-redux'
import { getNote, saveNote } from './actions'
import CKEditor from '@ckeditor/ckeditor5-react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

class NoteEditor extends Component {
  componentDidMount() {
    let { dispatch, entity, entityId, type = 'default' } = this.props
    dispatch(getNote(entity, entityId, type))
  }

  saveNote = () => {
    let { dispatch, entity, entityId, type = 'default', notes, relatedInterview = false } = this.props
    dispatch(
      saveNote(
        entity,
        entityId,
        type,
        notes.getIn([`${entity}.${entityId}.${type}`, 'note', 'content']),
        relatedInterview
      )
    )
  }

  render() {
    let { entity, entityId, type: noteType, notes, dispatch } = this.props
    let data = notes.get(`${entity}.${entityId}.${noteType}`, Map())
    let loading = data.get('loading', false)
    let initialLoad = data.get('initialLoad', false)
    let error = data.get('error', false)
    let open = data.get('open', false)
    let editing = data.get('editing', false)
    let note = data.get('note') || Map()

    let classes = ['notepad']
    if (editing) classes.push('notepad--editing')

    return (
      <Fragment>
        {editing ? <div className="notepad-edit-overlay" onClick={e => e.preventDefault() & this.saveNote()} /> : null}
        <div className={classes.join(' ')}>
          {error ? (
            <div className="notepad-error">
              <Message error content={error} />
            </div>
          ) : null}
          {!initialLoad ? (
            <div className="notepad-faker" />
          ) : editing ? (
            <div className="notepad-editor">
              <div className="notepad-actions">
                <button onClick={e => e.preventDefault() & this.saveNote()}>
                  <Icon name="save" /> Tallenna
                </button>
                <button
                  onClick={e =>
                    e.preventDefault() & dispatch({ type: 'NOTE_CLOSE', entity, entity_id: entityId, noteType })
                  }>
                  <Icon name="times" /> Sulje
                </button>
              </div>
              <div className="notepad-editor-content">
                <CKEditor
                  editor={ClassicEditor}
                  data={note.get('content', '')}
                  onInit={editor => editor.ui.view.editable.element.focus()}
                  onChange={(event, editor) =>
                    dispatch({ type: 'NOTE_CHANGE', entity, entity_id: entityId, noteType, content: editor.getData() })
                  }
                />
              </div>
            </div>
          ) : (
            <div
              className={`notepad-preview notepad-preview--${open ? 'open' : 'closed'}`}
              onDoubleClick={e => dispatch({ type: 'NOTE_EDIT', entity, entity_id: entityId, noteType })}>
              <div className="notepad-actions">
                <button
                  onClick={e =>
                    e.preventDefault() & dispatch({ type: 'NOTE_EDIT', entity, entity_id: entityId, noteType })
                  }>
                  <Icon name="edit" />
                  Muokkaa
                </button>
                <button
                  onClick={e =>
                    e.preventDefault() & dispatch({ type: 'NOTE_CLOSE', entity, entity_id: entityId, noteType })
                  }>
                  <Icon name="times" />
                  Sulje
                </button>
              </div>
              {!note.get('content', '') ? (
                <div className="notepad-preview-placeholder">Muokkaa muistiinpanoa</div>
              ) : (
                <div
                  className="notepad-preview-content"
                  dangerouslySetInnerHTML={{ __html: note.get('content', '') }}
                />
              )}
              <div
                className="notepad-preview-overlay"
                onClick={e =>
                  dispatch({
                    type: !note.get('content', '') ? 'NOTE_EDIT' : 'NOTE_OPEN',
                    entity,
                    entity_id: entityId,
                    noteType,
                  })
                }
              />
            </div>
          )}
          <Dimmer active={loading} inverted>
            <Loader />
          </Dimmer>
        </div>
      </Fragment>
    )
  }
}

export default connect(state => ({
  notes: state.notes,
}))(NoteEditor)
